import { Component } from 'react';

import TriggerContext from './TriggerContext';

class TriggerProvider extends Component {
  state = {
    triggers: {},
  };

  callbacks = {
    open: {},
    close: {},
  };

  handleGetTrigger = (id) => {
    if (!this.state.triggers[id]) {
      return {
        isOpen: false,
        onOpen: (fn) => {
          this.callbacks.open[id] = fn;
        },
        onClose: (fn) => {
          this.callbacks.close[id] = fn;
        },
      };
    }

    const trigger = this.state.triggers[id];

    const open = (anchor) => () => {
      this.setState(
        (state) => ({
          triggers: {
            ...state.triggers,
            [id]: {
              ...state.triggers[id],
              anchor,
              isOpen: true,
            },
          },
        }),
        () => {
          if (this.callbacks.open[id]) {
            this.callbacks.open[id]();
          }
        }
      );
    };

    const close = () => {
      this.setState(
        (state) => ({
          triggers: {
            ...state.triggers,
            [id]: {
              ...state.triggers[id],
              isOpen: false,
            },
          },
        }),
        () => {
          if (this.callbacks.close[id]) {
            this.callbacks.close[id]();
          }
        }
      );
    };

    return {
      isOpen: trigger.isOpen,
      anchor: trigger.anchor,
      onOpen: (fn) => {
        this.callbacks.open[id] = fn;
      },
      onClose: (fn) => {
        this.callbacks.close[id] = fn;
      },

      toggle: (anchor) => () => {
        if (this.state.triggers[id].isOpen) {
          close();
        } else {
          open(anchor)();
        }
      },
      open,
      close,
    };
  };

  handleAddTrigger = (id, props) => {
    this.setState((state) => {
      if (state.triggers[id]) {
        return state;
      }

      return {
        triggers: {
          ...state.triggers,
          [id]: {
            anchor: props.anchor,
            isOpen: props.isOpen,
          },
        },
      };
    });

    return () => {
      this.setState((state) => {
        const { [id]: removed, ...triggers } = state.triggers;

        this.callbacks.open[id] = null;
        this.callbacks.close[id] = null;

        return {
          triggers,
        };
      });
    };
  };

  render() {
    const { children } = this.props;
    return (
      <TriggerContext.Provider
        value={{
          getTrigger: this.handleGetTrigger,
          addTrigger: this.handleAddTrigger,
        }}
      >
        {children}
      </TriggerContext.Provider>
    );
  }
}

export default TriggerProvider;
